(function () {
  if (window.RegistaSearchEngine) return;

  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '16', '18', '20', '22', '24', '26', '28'];
  const STOP_WORDS = new Set(['shirt', 'shirts', 'jersey', 'jerseys', 'kit', 'kits', 'football', 'soccer', 'please', 'show', 'find', 'me', 'for', 'the', 'a', 'an']);

  const ENTITY_ALIASES = [
    ['Manchester United', ['man utd', 'man united', 'manchester utd', 'man u']],
    ['Manchester City', ['man city']],
    ['Tottenham Hotspur', ['tottenham', 'spurs']],
    ['FC Barcelona', ['barcelona', 'barca']],
    ['Real Madrid', ['real madrid cf']],
    ['Paris Saint-Germain', ['psg', 'paris saint germain', 'paris saint-germain']],
    ['AC Milan', ['ac milan']],
    ['Inter', ['inter milan', 'internazionale']],
    ['Juventus', ['juve']],
    ['AS Roma', ['roma', 'as roma']],
    ['Bayern Munich', ['bayern', 'fc bayern', 'bayern munchen', 'bayern münchen']],
    ['Borussia Dortmund', ['dortmund', 'bvb']],
    ['Atletico Madrid', ['atletico', 'atlético madrid', 'atletico madrid']],
    ['Athletic Bilbao', ['athletic club', 'bilbao']],
    ['Paris Saint-Germain', ['paris sg']],
    ['Netherlands', ['holland', 'dutch']],
    ['Ivory Coast', ['cote d ivoire', "cote d'ivoire", 'côte d’ivoire']],
    ['Brazil', ['brasil']],
    ['Cristiano Ronaldo', ['cr7', 'c ronaldo', 'c. ronaldo']],
    ['Ronaldo', ['r9', 'ronaldo nazario', 'ronaldo nazário', 'the phenomenon']],
    ['Lionel Messi', ['leo messi', 'messi']],
    ['Thierry Henry', ['henry']],
    ['David Beckham', ['beckham']],
    ['Ronaldinho', ['ronaldinho gaucho', 'ronaldinho gaúcho']],
    ['Zinedine Zidane', ['zidane', 'zizou']],
    ['Diego Maradona', ['maradona']],
    ['Neymar', ['neymar jr']],
    ['Kylian Mbappe', ['mbappe', 'mbappé']],
    ['Mohamed Salah', ['m salah', 'm. salah']],
    ['Erling Haaland', ['haaland']],
    ['Wayne Rooney', ['rooney']],
    ['Steven Gerrard', ['gerrard']],
    ['Frank Lampard', ['lampard']],
    ['Dennis Bergkamp', ['bergkamp']],
    ['Patrick Vieira', ['vieira']],
    ['Robert Pires', ['pires', 'pirès']],
    ['Francesco Totti', ['totti']],
    ['Paolo Maldini', ['maldini']],
    ['Alessandro Del Piero', ['del piero']],
    ['Didier Drogba', ['drogba']],
    ['Kaka', ['kaka', 'kaká']]
  ];

  const TYPE_PATTERNS = [
    { value: 'long sleeve', patterns: ['long sleeve', 'long-sleeve', 'longsleeve'] },
    { value: 'goalkeeper', patterns: ['goalkeeper', 'goal keeper', 'keeper', 'gk'] },
    { value: 'training', patterns: ['training', 'training top'] },
    { value: 'jacket', patterns: ['windbreaker', 'jacket'] },
    { value: 'hoodie', patterns: ['hoodie', 'hoody'] },
    { value: 'third', patterns: ['third kit', 'third shirt', 'third'] },
    { value: 'away', patterns: ['away kit', 'away shirt', 'away'] },
    { value: 'home', patterns: ['home kit', 'home shirt', 'home'] }
  ];

  function text(value) {
    return String(value == null ? '' : value);
  }

  function normalize(value) {
    let result = text(value).toLowerCase();
    if (typeof result.normalize === 'function') result = result.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return result
      .replace(/[\u0591-\u05C7]/g, '')
      .replace(/[’'"`]/g, '')
      .replace(/[–—_]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeRegExp(value) {
    return text(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function canonicalizeAliases(value) {
    let clean = ' ' + normalize(value) + ' ';
    const replacements = [];
    ENTITY_ALIASES.forEach(function (entry) {
      const canonical = normalize(entry[0]);
      entry[1].forEach(function (alias) {
        const normalizedAlias = normalize(alias);
        if (normalizedAlias && normalizedAlias !== 'ronaldo' && normalizedAlias !== 'milan') {
          replacements.push({ from: normalizedAlias, to: canonical });
        }
      });
    });
    replacements.sort(function (a, b) { return b.from.length - a.from.length; });
    replacements.forEach(function (item) {
      const pattern = new RegExp('(^|\\s)' + escapeRegExp(item.from).replace(/\\ /g, '\\s+') + '(?=\\s|$)', 'g');
      clean = clean.replace(pattern, function (_, prefix) { return prefix + item.to; });
    });
    return clean.replace(/\s+/g, ' ').trim();
  }

  function normalizeSize(value) {
    const clean = normalize(value).replace(/\s+/g, '').replace(/\+/g, '');
    if (clean === 'xxxl') return '3XL';
    if (/^[x]{1,2}s$/.test(clean)) return clean.toUpperCase();
    if (/^(s|m|l|xl|xxl|3xl|4xl|5xl)$/.test(clean)) return clean.toUpperCase();
    if (/^(16|18|20|22|24|26|28)$/.test(clean)) return clean;
    return text(value).toUpperCase().trim();
  }

  function sizeCandidates(size) {
    const clean = normalizeSize(size);
    if (clean === '3XL') return ['3XL', 'XXXL'];
    return [clean];
  }

  function availableSizes(product) {
    const map = product && product.hm && typeof product.hm === 'object' ? product.hm : {};
    const sizes = Object.keys(map)
      .filter(function (key) { return key && key.toUpperCase() !== 'DEFAULT' && map[key]; })
      .map(normalizeSize)
      .filter(function (size, index, arr) { return size && arr.indexOf(size) === index; });
    return sizes.sort(function (a, b) {
      const ai = SIZE_ORDER.indexOf(a);
      const bi = SIZE_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }

  function hasAnySize(product, sizes) {
    if (!Array.isArray(sizes) || !sizes.length) return true;
    const available = availableSizes(product);
    return sizes.some(function (size) {
      return sizeCandidates(size).some(function (candidate) { return available.includes(candidate); });
    });
  }

  function resolveHandle(product, size) {
    if (!product) return '';
    const map = product.hm && typeof product.hm === 'object' ? product.hm : {};
    if (size) {
      const wanted = sizeCandidates(size);
      const keys = Object.keys(map);
      for (let i = 0; i < keys.length; i += 1) {
        const normalizedKey = normalizeSize(keys[i]);
        if (wanted.includes(normalizedKey) && map[keys[i]]) return map[keys[i]];
      }
    }
    return product.h || map.DEFAULT || Object.keys(map).map(function (key) { return map[key]; }).find(Boolean) || '';
  }

  function stripOnce(source, pattern) {
    return source.replace(pattern, ' ').replace(/\s+/g, ' ').trim();
  }

  function parseSeason(source) {
    let working = source;
    let season = null;
    let decade = null;
    let match = working.match(/\b((?:19|20)\d{2})\s*[-/]\s*((?:19|20)?\d{2})\b/);
    if (match) {
      const start = Number(match[1]);
      let endRaw = Number(match[2]);
      const end = match[2].length === 2 ? Math.floor(start / 100) * 100 + endRaw : endRaw;
      season = { kind: 'range', start: start, end: end, raw: match[0] };
      working = stripOnce(working, new RegExp(escapeRegExp(match[0])));
      return { working: working, season: season, decade: decade };
    }

    match = working.match(/\b(\d{2})\s*[-/]\s*(\d{2})\b/);
    if (match) {
      const startShort = Number(match[1]);
      const endShort = Number(match[2]);
      const start = startShort >= 70 ? 1900 + startShort : 2000 + startShort;
      const end = endShort >= 70 ? 1900 + endShort : 2000 + endShort;
      season = { kind: 'range', start: start, end: end, raw: match[0] };
      working = stripOnce(working, new RegExp(escapeRegExp(match[0])));
      return { working: working, season: season, decade: decade };
    }

    match = working.match(/\b((?:19|20)?\d0)s\b/);
    if (match) {
      let decadeValue = Number(match[1]);
      if (match[1].length === 2) decadeValue = decadeValue >= 70 ? 1900 + decadeValue : 2000 + decadeValue;
      decade = decadeValue;
      working = stripOnce(working, new RegExp(escapeRegExp(match[0])));
      return { working: working, season: season, decade: decade };
    }

    match = working.match(/\b((?:19|20)\d{2})\b/);
    if (match) {
      season = { kind: 'year', year: Number(match[1]), raw: match[0] };
      working = stripOnce(working, new RegExp(escapeRegExp(match[0])));
    }

    return { working: working, season: season, decade: decade };
  }

  function parseQuery(rawQuery) {
    const raw = text(rawQuery).trim();
    let working = normalize(raw);
    const intent = {
      raw: raw,
      normalized: working,
      core: '',
      terms: [],
      size: '',
      season: null,
      decade: null,
      type: '',
      sleeve: ''
    };

    let sizeMatch = working.match(/(?:^|\s)(3xl\+?|xxxl|xxl|xl|xs|s|m|l)(?=\s|$)/i);
    if (!sizeMatch) sizeMatch = working.match(/\bsize\s*(16|18|20|22|24|26|28)\b/i);
    if (sizeMatch) {
      intent.size = normalizeSize(sizeMatch[1]);
      working = stripOnce(working, new RegExp('(^|\\s)' + escapeRegExp(sizeMatch[0].trim()) + '(?=\\s|$)', 'i'));
    }

    for (let i = 0; i < TYPE_PATTERNS.length; i += 1) {
      const typeGroup = TYPE_PATTERNS[i];
      let found = '';
      for (let j = 0; j < typeGroup.patterns.length; j += 1) {
        const pattern = normalize(typeGroup.patterns[j]);
        const regex = new RegExp('(^|\\s)' + escapeRegExp(pattern).replace(/\\ /g, '\\s+') + '(?=\\s|$)', 'i');
        if (regex.test(working)) {
          found = pattern;
          working = working.replace(regex, ' ').replace(/\s+/g, ' ').trim();
          break;
        }
      }
      if (found) {
        if (typeGroup.value === 'long sleeve') intent.sleeve = 'long sleeve';
        else intent.type = typeGroup.value;
        break;
      }
    }

    const seasonResult = parseSeason(working);
    working = seasonResult.working;
    intent.season = seasonResult.season;
    intent.decade = seasonResult.decade;

    intent.core = canonicalizeAliases(working);
    intent.terms = intent.core
      .split(/[^a-z0-9]+/)
      .filter(Boolean)
      .filter(function (term) { return !STOP_WORDS.has(term); });
    return intent;
  }

  function levenshtein(a, b) {
    const first = text(a);
    const second = text(b);
    if (first === second) return 0;
    if (!first.length) return second.length;
    if (!second.length) return first.length;
    const previous = new Array(second.length + 1);
    const current = new Array(second.length + 1);
    for (let j = 0; j <= second.length; j += 1) previous[j] = j;
    for (let i = 1; i <= first.length; i += 1) {
      current[0] = i;
      for (let j = 1; j <= second.length; j += 1) {
        current[j] = Math.min(
          current[j - 1] + 1,
          previous[j] + 1,
          previous[j - 1] + (first[i - 1] === second[j - 1] ? 0 : 1)
        );
      }
      for (let j = 0; j <= second.length; j += 1) previous[j] = current[j];
    }
    return previous[second.length];
  }

  function fuzzyTermMatch(term, field) {
    const cleanTerm = normalize(term);
    const cleanField = normalize(field);
    if (!cleanTerm || !cleanField) return false;
    if (cleanField.includes(cleanTerm)) return true;
    if (cleanTerm.length < 4) return false;
    const maxDistance = cleanTerm.length >= 8 ? 2 : 1;
    const fieldWords = cleanField.split(/[^a-z0-9]+/).filter(Boolean);
    return fieldWords.some(function (word) {
      if (Math.abs(word.length - cleanTerm.length) > maxDistance) return false;
      return levenshtein(cleanTerm, word) <= maxDistance;
    });
  }

  function uniqueNormalized(values) {
    const seen = {};
    return values.map(normalize).filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    }).join(' ');
  }

  function prepareProduct(product) {
    if (!product.__rse) {
      product.__rse = {
        title: uniqueNormalized([product.e, product.t]),
        team: uniqueNormalized([product.tm, product.tmh]),
        country: uniqueNormalized([product.co, product.coh]),
        player: uniqueNormalized([product.hr, product.hrh]),
        type: normalize(product.ty),
        handle: normalize(product.h),
        haystack: uniqueNormalized([product.e, product.t, product.tm, product.tmh, product.co, product.coh, product.hr, product.hrh, product.ty, product.h, product.s])
      };
    }
    return product;
  }

  function prepareProducts(products) {
    return (Array.isArray(products) ? products : []).map(prepareProduct);
  }

  function yearsFromSource(sourceValue) {
    const source = normalize(sourceValue);
    const years = [];
    let match;
    const longRegex = /\b((?:19|20)\d{2})\b/g;
    while ((match = longRegex.exec(source))) years.push(Number(match[1]));
    const shortRegex = /(?:^|[^0-9])(\d{2})(?=[^0-9]|$)/g;
    while ((match = shortRegex.exec(source))) {
      const value = Number(match[1]);
      if (value >= 70) years.push(1900 + value);
      else if (value <= 40) years.push(2000 + value);
    }
    return years.filter(function (year, index, arr) { return year >= 1970 && year <= 2040 && arr.indexOf(year) === index; });
  }

  function productYears(product) {
    const titleYears = yearsFromSource(product.e || product.t || '');
    if (titleYears.length) return titleYears;
    return yearsFromSource(product.h || '');
  }

  function seasonMatches(product, intent) {
    if (!intent.season && !intent.decade) return true;
    const years = productYears(product);
    if (intent.decade) return years.some(function (year) { return Math.floor(year / 10) * 10 === intent.decade; });
    if (intent.season.kind === 'year') return years.includes(intent.season.year);
    if (intent.season.kind === 'range') return years.includes(intent.season.start) && years.includes(intent.season.end);
    return true;
  }

  function typeMatches(product, intent) {
    if (!intent.type && !intent.sleeve) return true;
    const fields = product.__rse || prepareProduct(product).__rse;
    const titleSource = normalize(product.e || product.t || '');
    const fallbackSource = normalize([product.ty, product.h].join(' '));
    const source = titleSource || fallbackSource;
    if (intent.sleeve && !source.includes('long sleeve') && !source.includes('long-sleeve')) return false;
    if (!intent.type) return true;
    if (intent.type === 'goalkeeper') return /goalkeeper|goal keeper|keeper|\bgk\b/.test(source);
    if (intent.type === 'jacket') return /jacket|windbreaker/.test(source);
    return source.includes(intent.type);
  }

  function phraseMatch(field, phrase) {
    const cleanField = normalize(field);
    const cleanPhrase = normalize(phrase);
    return Boolean(cleanField && cleanPhrase && (cleanField === cleanPhrase || cleanField.includes(cleanPhrase)));
  }

  function termFieldScore(term, fields) {
    if (phraseMatch(fields.player, term)) return { score: 42, field: 'player' };
    if (phraseMatch(fields.team, term)) return { score: 38, field: 'team' };
    if (phraseMatch(fields.title, term)) return { score: 30, field: 'title' };
    if (phraseMatch(fields.country, term)) return { score: 22, field: 'country' };
    if (phraseMatch(fields.haystack, term)) return { score: 14, field: 'other' };

    if (fuzzyTermMatch(term, fields.player)) return { score: 27, field: 'player' };
    if (fuzzyTermMatch(term, fields.team)) return { score: 24, field: 'team' };
    if (fuzzyTermMatch(term, fields.title)) return { score: 19, field: 'title' };
    if (fuzzyTermMatch(term, fields.country)) return { score: 14, field: 'country' };
    if (fuzzyTermMatch(term, fields.haystack)) return { score: 8, field: 'other' };
    return null;
  }

  function scoreProduct(product, intent, options) {
    prepareProduct(product);
    const fields = product.__rse;
    const selectedSizes = Array.isArray(options && options.sizes) && options.sizes.length
      ? options.sizes.map(normalizeSize)
      : (intent.size ? [intent.size] : []);

    if (!hasAnySize(product, selectedSizes)) return null;
    if (!seasonMatches(product, intent)) return null;
    if (!typeMatches(product, intent)) return null;
    if (options && options.audience === 'kids' && !product.k) return null;
    if (options && options.audience && options.audience !== 'kids' && product.k) return null;

    let score = 0;
    let matchedTeam = false;
    let matchedCountry = false;
    let matchedPlayer = false;
    let matchedTitle = false;

    if (intent.core) {
      if (phraseMatch(fields.player, intent.core)) { score += 190; matchedPlayer = true; }
      if (phraseMatch(fields.team, intent.core)) { score += 180; matchedTeam = true; }
      if (phraseMatch(fields.title, intent.core)) { score += 145; matchedTitle = true; }
      if (phraseMatch(fields.country, intent.core)) { score += 95; matchedCountry = true; }
    }

    for (let i = 0; i < intent.terms.length; i += 1) {
      const match = termFieldScore(intent.terms[i], fields);
      if (!match) return null;
      score += match.score;
      if (match.field === 'team') matchedTeam = true;
      if (match.field === 'country') matchedCountry = true;
      if (match.field === 'player') matchedPlayer = true;
      if (match.field === 'title') matchedTitle = true;
    }

    const method = options && options.method ? options.method : 'smart';
    if (method === 'team' && intent.terms.length && !matchedTeam && !matchedTitle) return null;
    if (method === 'country' && intent.terms.length && !matchedCountry) return null;
    if (method === 'player' && intent.terms.length && !matchedPlayer && !matchedTitle) return null;

    if (method === 'team' && matchedTeam) score += 45;
    if (method === 'country' && matchedCountry) score += 45;
    if (method === 'player' && (matchedPlayer || matchedTitle)) score += 50;
    if (method === 'era' && (intent.season || intent.decade)) score += 45;

    if (intent.size || selectedSizes.length) score += 20;
    if (intent.season || intent.decade) score += 28;
    if (intent.type || intent.sleeve) score += 22;
    if (product.i) score += 3;

    const type = fields.type;
    const heroLike = type === 'heros' || type === 'heroes';
    const titleLooksLikeShirt = /shirt|jersey|kit/.test(fields.title);
    const shirtLike = type === 'football shirt' || heroLike || type === 'training' || (!type && titleLooksLikeShirt);
    if (options && options.shirtsOnly && !shirtLike) return null;
    if (matchedPlayer && heroLike) score += 35;
    else if (heroLike && !matchedPlayer) score -= 24;
    if (options && options.preferShirts && shirtLike) score += 20;
    if (options && options.preferShirts && !shirtLike && !intent.type) score -= 18;

    if (!intent.terms.length && !intent.size && !intent.season && !intent.decade && !intent.type && !intent.sleeve) return null;

    const resolvedSize = selectedSizes.length === 1 ? selectedSizes[0] : (intent.size || '');
    return {
      product: product,
      score: score,
      handle: resolveHandle(product, resolvedSize),
      selectedSize: resolvedSize,
      matched: {
        team: matchedTeam,
        country: matchedCountry,
        player: matchedPlayer,
        title: matchedTitle
      }
    };
  }

  function search(products, rawQuery, options) {
    const settings = options || {};
    const intent = parseQuery(rawQuery);
    const prepared = prepareProducts(products);
    const used = {};
    const scored = [];

    prepared.forEach(function (product) {
      const result = scoreProduct(product, intent, settings);
      if (!result || !result.handle) return;
      const key = product.h || result.handle;
      if (used[key]) return;
      used[key] = true;
      scored.push(result);
    });

    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return normalize(a.product.e || a.product.t).localeCompare(normalize(b.product.e || b.product.t));
    });

    const limit = Number(settings.limit || scored.length || 0);
    return { intent: intent, results: scored.slice(0, limit) };
  }

  function entityMatches(label, query) {
    const field = canonicalizeAliases(label);
    const intent = parseQuery(query);
    if (!intent.core) return false;
    if (field.includes(intent.core) || intent.core.includes(field)) return true;
    return intent.terms.every(function (term) { return fuzzyTermMatch(term, field); });
  }

  function suggestions(products, rawQuery, limit) {
    const map = {};
    const intent = parseQuery(rawQuery);
    if (!intent.core) return [];
    prepareProducts(products).forEach(function (product) {
      [
        [product.tmh || product.tm, 'Team'],
        [product.hrh || product.hr, 'Player'],
        [product.coh || product.co, 'Country']
      ].forEach(function (entry) {
        const label = text(entry[0]).trim();
        if (!label || !entityMatches(label, rawQuery)) return;
        const key = normalize(entry[1] + ':' + canonicalizeAliases(label));
        if (!map[key]) map[key] = { label: label, type: entry[1], count: 0 };
        map[key].count += 1;
      });
    });
    return Object.keys(map).map(function (key) { return map[key]; }).sort(function (a, b) {
      if (b.count !== a.count) return b.count - a.count;
      return a.label.length - b.label.length;
    }).slice(0, Number(limit || 6));
  }

  function seasonLabel(intent) {
    if (intent.decade) return String(intent.decade) + 's';
    if (!intent.season) return '';
    if (intent.season.kind === 'year') return String(intent.season.year);
    const end = String(intent.season.end).slice(-2);
    return String(intent.season.start) + '/' + end;
  }

  function typeLabel(value) {
    const labels = { home: 'Home', away: 'Away', third: 'Third', goalkeeper: 'Goalkeeper', training: 'Training', jacket: 'Jacket', hoodie: 'Hoodie' };
    return labels[value] || text(value);
  }

  function intentChips(intent) {
    const chips = [];
    if (intent.core) chips.push(intent.core.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); }));
    if (intent.type) chips.push(typeLabel(intent.type));
    if (intent.sleeve) chips.push('Long Sleeve');
    const season = seasonLabel(intent);
    if (season) chips.push(season);
    if (intent.size) chips.push('Size ' + intent.size);
    return chips;
  }

  function queryWithFilters(label, intent) {
    const parts = [text(label).trim()];
    if (intent.type) parts.push(typeLabel(intent.type));
    if (intent.sleeve) parts.push('Long Sleeve');
    const season = seasonLabel(intent);
    if (season) parts.push(season);
    if (intent.size) parts.push(intent.size);
    return parts.filter(Boolean).join(' ');
  }

  window.RegistaSearchEngine = {
    version: '1.0.0',
    normalize: normalize,
    normalizeSize: normalizeSize,
    parseQuery: parseQuery,
    prepareProducts: prepareProducts,
    search: search,
    suggestions: suggestions,
    availableSizes: availableSizes,
    hasAnySize: hasAnySize,
    resolveHandle: resolveHandle,
    intentChips: intentChips,
    queryWithFilters: queryWithFilters,
    seasonLabel: seasonLabel,
    typeLabel: typeLabel
  };
})();
